import React from 'react';
import { Box, Button } from '@mui/material';

type Props = {
  prefix?: React.ReactNode;
  actionText?: string;
  suffix?: React.ReactNode;
  onClick?: () => void;
};

export function AccountExpirationSnackbar({ prefix, actionText, suffix, onClick }: Props) {
  return (
    <Box component="span" sx={{ fontSize: 14, lineHeight: 1.43 }}>
      {prefix}
      {actionText ? (
        <span>
          <Button variant="primaryText" onClick={onClick}>
            {actionText}
          </Button>
        </span>
      ) : null}
      {suffix}
    </Box>
  );
}
